import { render, staticRenderFns } from "./wisdom_expert.vue?vue&type=template&id=8da8638e&scoped=true&"
import script from "./wisdom_expert.vue?vue&type=script&lang=js&"
export * from "./wisdom_expert.vue?vue&type=script&lang=js&"
import style0 from "./wisdom_expert.vue?vue&type=style&index=0&id=8da8638e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da8638e",
  null
  
)

export default component.exports